import React, { useState } from 'react';
import axiosInstance from '../utils/axiosInstance';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useSnackbar } from '../contexts/SnackbarProvider';

function PdfPrintButton({ id, isEditMode, pdfType, label, onAfterDownload }) {
    const { showSnackbar } = useSnackbar();
    const [downloading, setDownloading] = useState(false);

    const handleDownload = async () => {
        if (isEditMode || !id || downloading) return;

        setDownloading(true);

        try {
            const response = await axiosInstance.get(`/pdf/${pdfType}/${id}`, {
                responseType: 'blob'
            });

            let filename = `${label}.pdf`;
            const disposition = response.headers['content-disposition'];

            if (disposition) {
                const match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
                if (match?.[1]) filename = decodeURIComponent(match[1]);
            }

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

            onAfterDownload?.();

        } catch (err) {
            console.error(err);

            let message = 'データの取得に失敗しました';

            if (err.response?.data instanceof Blob) {
                try {
                    const text = await err.response.data.text();
                    const json = JSON.parse(text);
                    message = json.message || message;
                } catch { }
            } else {
                message = err.response?.data?.message || message;
            }

            showSnackbar(message, 'error');
        } finally {
            setDownloading(false);
        }
    };

    return (
        <Button
            type="button"
            disabled={isEditMode || !id || downloading}
            onClick={handleDownload}
            variant="outlined"
            size="small"
            endIcon={<DownloadIcon />}
        >
            {downloading ? 'ダウンロード中…' : `${label}のダウンロード`}
        </Button>
    );
}

export default PdfPrintButton;